import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=a5c28f8c&scoped=true"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"
import style0 from "./TableInput.vue?vue&type=style&index=0&id=a5c28f8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c28f8c",
  null
  
)

export default component.exports